import { getStatusFromStorage } from './getStatusFromStorage';

interface HasBeenDismissedParams {
  forceShow?: boolean;
  storageKey: string;
  storageType?: 'localStorage' | 'sessionStorage';
}

export const hasBeenDismissed = ({
  storageKey,
  storageType = 'localStorage',
  forceShow,
}: HasBeenDismissedParams) => {
  // If forceShow is true, always return false (not dismissed)
  if (forceShow) {
    return false;
  }

  const status = getStatusFromStorage({
    storageKey,
    storageType,
  });

  /*
   * In local storage, a dismissed popup has a status of `true`.
   * and a status of `false` or `undefined` if it has not been dismissed
   */
  if (status) {
    return true;
  }

  return false;
};
